export default "__VITE_ASSET__7xc$cjoW__"